import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { configurationApi } from "~/api";
import { getErrorMessage } from "~/hooks/helpers";
import type { Brand } from "~/types/api";

const fetchBrands = async (): Promise<Brand[]> => {
  const response = await configurationApi.client.GET("/api/Brand");

  if (response?.error) {
    throw new Error(getErrorMessage(response.error, "Failed to fetch brands"));
  }

  return response.data || [];
};

export const useBrandsQuery = (
  options?: Omit<UseQueryOptions<Brand[], Error>, "queryKey" | "queryFn">
) => {
  return useQuery<Brand[], Error>({
    queryKey: configurationApi.queryOptions("get", "/api/Brand").queryKey,
    queryFn: () => fetchBrands(),
    retry: 1,
    meta: {
      errorTitle: "Failed to load brands",
    },
    ...options,
  });
};
